import { TourStatus, TourStep, TourStepRaw } from 'app/tour/index';
import TourStepLifeCycle from 'app/tour/TourStepLifeCycle';
import TourSpotlight from 'app/tour/TourSpotlight';

export default class AppTour {
    private _isActive: boolean = false;
    private _stepIndex: number = -1;
    private _isStepTransition: boolean = false;
    private _steps: Array<TourStep> = [];
    // Should be set by the child class
    rawSteps: Array<TourStepRaw> = [];
    static tourName: string = '';
    spotlight = new TourSpotlight();

    prepareSteps() {
        this._steps = this.rawSteps.map((rawStep) => {
            return {
                offset: 0,
                ...rawStep,
                disableBeacon: true,
                lifeCycle: rawStep.lifeCycle || new TourStepLifeCycle(this),
                waitForSelector: rawStep.waitForSelector ?? true,
            } as TourStep;
        });
    }

    constructor(public setTourStatus: (status: TourStatus) => void) {}
    async startTour(): Promise<any> {
        this.prepareSteps();
        await this.goToNextStep();
        this.setIsActive(true);
    }
    async goToNextStep(): Promise<any> {
        if (this._steps.length == this._stepIndex) {
            return this.endTour();
        }
        this.setIsStepTransition(true);
        if (this._stepIndex != -1) {
            const currentStep = this._steps[this._stepIndex];
            const beforeClose = await currentStep.lifeCycle?.onBeforeClose(currentStep);
            // TODO: handle afterClose ?
        }
        const nextStep = this._steps[this._stepIndex + 1];
        await nextStep.lifeCycle?.onBeforeStart(nextStep, false);
        this.setStep(this._stepIndex + 1);
        return Promise.resolve(true);
    }
    async goToPreviousStep(): Promise<any> {
        this.setIsStepTransition(true);
        const currentStep = this._steps[this._stepIndex];
        const beforeClose = await currentStep.lifeCycle?.onBeforeClose(currentStep);
        // TODO: handle afterClose ?

        const nextStep = this._steps[this._stepIndex - 1];

        return new Promise(async (resolve) => {
            await nextStep.lifeCycle?.onBeforeStart(nextStep, false);
            this.setStep(this._stepIndex - 1);
            resolve(true);
        });
    }
    async endTour(): Promise<any> {
        this.setIsActive(false);
        this.setStep(-1);
        return Promise.resolve(true);
    }

    getTourStatus(): TourStatus {
        return {
            isActive: this._isActive,
            stepIndex: this._stepIndex < 0 ? 0 : this._stepIndex,
            isStepTransition: this._isStepTransition,
            steps: this._steps,
        };
    }

    setStep(newIndex: number) {
        this._stepIndex = newIndex;
        this._isStepTransition = false;
        this.onTourStatusChange();
    }
    setIsActive(isActive: boolean) {
        this._isActive = isActive;
        this.onTourStatusChange();
    }
    setIsStepTransition(isStepTransition: boolean) {
        this._isStepTransition = isStepTransition;
        this.onTourStatusChange();
    }
    onTourStatusChange() {
        this.setTourStatus(this.getTourStatus());
    }
}
